export default {
  computed: {
    currentUser() {
      return this.$store.state.users.currentUser;
    },
    full_name() {
      return this.currentUser?.first_name + ' ' + this.currentUser?.last_name;
    },
    email() {
      return this.currentUser?.email;
    },
    companyName() {
      return this.currentUser?.company?.legal_name;
    },
    verified() {
      return this.currentUser?.is_verified_email;
    },
    preferred_name() {
      return this.currentUser?.preferred_name;
    },
  },
};
